import { DeleteIcon, InfiniteTable } from '@/components/_common';
import {
  useDeletePartVehicleApplicationFree,
  usePartVehicleApplicationsFree,
} from '@/core/domain/operational/PartVehicleApplications/PartVehicleApplications.hooks';
import { PartVehicleApplicationFree } from '@/core/domain/operational/PartVehicleApplications/PartVehicleApplications.types';
import { Modal } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useIntl } from 'react-intl';

interface Props {
  partId: number;
}

const PartApplicationFreeList: React.FC<Props> = ({ partId }) => {
  const { data, isLoading } = usePartVehicleApplicationsFree(partId);
  const intl = useIntl();

  const removeMutation = useDeletePartVehicleApplicationFree();

  const handleRemoveClick = (id: number) => {
    Modal.confirm({
      title: intl.formatMessage({ id: 'parts.application.modal.remove.title' }),
      content: intl.formatMessage({
        id: 'parts.application.modal.remove.content',
      }),
      onOk: async () => {
        await removeMutation.mutateAsync(id);
      },
      okType: 'danger',
    });
  };

  const columns: ColumnsType<PartVehicleApplicationFree> = [
    {
      dataIndex: 'description',
      title: 'Descrição',
      ellipsis: true,
      width: 220,
    },
    {
      dataIndex: 'fromYear',
      title: intl.formatMessage({
        id: 'parts.application.modal.form.fromYear',
      }),
      ellipsis: true,
      width: 220,
    },
    {
      dataIndex: 'toYear',
      title: intl.formatMessage({ id: 'parts.application.modal.form.toYear' }),
      ellipsis: true,
      width: 140,
    },
    {
      dataIndex: 'actions',
      title: intl.formatMessage({ id: 'commons.list.header.action' }),
      render: (_, record) => (
        <DeleteIcon onClick={() => handleRemoveClick(record.id)} />
      ),
      ellipsis: true,
      width: 100,
      align: 'right',
      fixed: 'right',
    },
  ];

  return (
    <InfiniteTable<PartVehicleApplicationFree>
      dataSource={data?.data}
      columns={columns}
      pagination={false}
      loading={isLoading}
      rowKey={(row) => row.id}
    />
  );
};

export default PartApplicationFreeList;
